document.addEventListener('DOMContentLoaded', function() {
    const dtList = document.querySelectorAll('.aside-list dt');

    dtList.forEach(dt => {
        dt.addEventListener('click', function() {
            this.classList.toggle('open');
        });
    });
});

//よくある質問
let questions = document.querySelectorAll('.question--js');
questions.forEach(function(question) {
    question.addEventListener('click', function(event){
        event.preventDefault();
        let faqList = this.closest('.faq-list--js');
        faqList.classList.toggle('open');
    });
});
